import React from 'react'
import { Button, Result } from 'antd'
import { useNavigate } from 'react-router-dom'

export default function ModuleInactivePage() {
  const navigate = useNavigate()

  return (
    <Result
      status="403"
      title="Модуль не подключён"
      subTitle="Данный раздел недоступен, так как соответствующий модуль не подключён."
      extra={
        <Button type="primary" onClick={() => navigate('/settings/modules')}>
          Перейти к модулям
        </Button>
      }
    />
  )
}
